<template lang="html">
  <div id="blog-page">

    <section class="main-section" data-aos="fade-in" data-aos-duration="1000">
      <div class="container med-container">
        <div class="row">
          <div class="col-12 col-title">
            <h2 class="title-s1">BLOG</h2>
          </div>

          <div class="col-12 col-results" v-if="!isLoading">
            <div class="row">
              <div class="col-lg-6 box-article-s1" v-for="(a, aInx) in blog" :key="'aInx-'+aInx">
                <router-link class="box" :to="'/blog/'+$root._converToURL(a.name, a.id)">
                  <div class="placed-backg box-image" v-bind:style="{ backgroundImage: 'url('+a.image+')' }"></div>

                  <div class="box-info">
                    <h5 class="title">{{ a.name }}</h5>

                    <div class="b-text" v-html="a.short_description"></div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>

          <LoadingComponent v-else></LoadingComponent>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import LoadingComponent from '../shared/loading-component.vue';
export default {
  components: {LoadingComponent},

  data() {
    return {
      isLoading: true,
      blog: [
        // { image: 'public/images/pages/blog/article-1.jpg',
        //   title: 'Los mejores diseños de macetas para adornar tu casa y darle un toque especial.',
        //   text: `
        //     Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
        //   `
        // },
      ],
    }
  },

  methods: {
    getBlog() {
      this.isLoading = true;
      axios.get(tools.url('/api/blog')).then((response) =>{
        this.blog = response.data;
        this.isLoading = false;
      }).catch((error)=>{
        console.log(error);
      });
    },
  },

  beforeMount() {
    this.getBlog();
  }
}
</script>
